
$(window).on("load",function(){
	$('html,body').scrollTop();
});
$(window).on("load scroll resize",function(){
  var target = $("#scrollArea");
  var scAreaNum = 1.65;//1.25
  var child = $("#scrollArea .sc_content");
  var child_in = $("#scrollArea .sc_single");
  var child_num = child.length;
  var winH = $(window).height();
  var sc_area = winH * child_num * scAreaNum;
  var stP = target.offset().top;
  var edP = target.offset().top + sc_area; 

  target.css("height",sc_area);

  var scT = $(window).scrollTop();
  var scTB = scT + winH;
    $("#scrollArea .sc_content").each(function(){
      var childTop = $(this).offset().top;
      var child_h = $(this).height();
      var childBottom = childTop + child_h;
      var scLength = Math.trunc((winH - (scT - childTop)) * 1);
      var scLengthTop = Math.trunc((winH - (scT - childTop)) * 1) - (winH);
      var scLeng = scLength + "px";
      var scLengTop = scLengthTop + "px";
      var delay = 50;
      var time = 140;
      var fade = 1.5;
      var appearance = 1.8;
      var opacity = appearance - ((delay + scLength - (scLength / fade)) / time) * -1;
      var opacityMin = appearance + ((delay + scLength - (scLength / fade)) / time) * -1;
      var opacityTop = appearance - ((delay + scLengthTop - (scLengthTop / fade)) / time) * -1;
      console.log(scLength);
      $(this).attr('data-num', opacity);
      $(this).find(".scImg").css("transform", "translateY(" + scLeng + ")");//,.scTxt,.scTxtBottom
      
      $(this).find(".scTxtTop").css("opacity", opacityTop);
      if (opacity >= 1){
        $(this).find(".scTxt,.scTxtBottom").css("opacity", opacityMin);
      } else {
        $(this).find(".scTxt").css("opacity", opacity);
      }
      if (scLength > winH){
        $(this).find(".scImg").css("transform", "translateY(" + winH + "px )");
        // $(this).find(".scTxtBottom").css("opacity", opacity);
      } else if(scLength <= 0) {
        $(this).find(".scImg").css("transform", "translateY(0)");//,.scTxtBottom
      } else if(scLengthTop <= 0) {
        // $(this).find(".scTxtTop").css("transform", "translateY(" + scLengTop + ")");
      } else if(scLengthTop >= 0) {
        // $(this).find(".scTxtTop").css("transform", "translateY(0)");
      }
      if (scT > childTop && scT <= childBottom){
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });
  if( scT >= stP && scTB <= edP){
    target.addClass("active");
    child_in.css("position","fixed");
    target.removeClass("sc_end");
  } else if( scT >= stP && scTB >= edP) {
    target.removeClass("active");
    child_in.removeClass("active");
    target.addClass("sc_end");
    child_in.css("position","absolute");
    child_in.css("top","auto");
    child_in.css("bottom","0");

  } else {
    target.removeClass("active");
    child_in.removeClass("active");
    child_in.css("position","absolute");
    child_in.css("top","0");
    child_in.css("bottom","auto");
  }
});